import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-metrics',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-metrics.component.html',
  styleUrl: './dashboard-metrics.component.scss'
})
export class DashboardMetricsComponent {
  @Input() metrics: any[] = [];
  @Input() accentColors: string[] = [];
  @Input() isLoading: boolean = false;
  @Output() metricClick = new EventEmitter<string>();

  getTrendIcon(trend: string): string {
    switch (trend) {
      case 'up':
        return '↗';
      case 'down':
        return '↘';
      default:
        return '→'; // Arrow for stable
    }
  }

  getTrendClass(trend: string): string {
    switch (trend) {
      case 'up':
        return 'up';
      case 'down':
        return 'down';
      default:
        return 'stable';
    }
  }

  getTrendLabel(trend: string): string {
    switch (trend) {
      case 'up':
        return 'Increasing';
      case 'down':
        return 'Decreasing';
      default:
        return 'Stable';
    }
  }

  onMetricClick(label: string) {
    this.metricClick.emit(label);
  }
}
